<template>
  <v-container fluid>
    <confirm-modal
      :dialog="showConfirm"
      :message="confirmMessage"
      @confirm="confirmResponse($event)"></confirm-modal>
    <v-layout row wrap>
      <v-flex xs6 md5 offset-md1 d-flex align-center>
        <h4 class="green--text mb-0 headline">Complejos</h4>
      </v-flex>
      <v-flex xs6 md5 text-xs-right>
        <v-tooltip left>
          <v-btn
            dark
            color="green"
            slot="activator"
            fab
            v-on:click="goNewComplex()"
            small>
              <v-icon>add</v-icon>
            </v-btn>
          <span>Nuevo Complejo</span>
        </v-tooltip>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 md10 offset-md1>
        <v-text-field
          box
          name="searchbar"
          label="Buscar complejos"
          append-icon="search"
          class="white--text"
          v-model="filter"></v-text-field>
      </v-flex>
      <v-flex xs12 md10 offset-md1>
        <v-data-table
        :rows-per-page-items="[25,50,100]"
          :headers="headers"
          :items="currentComplexes"
          :search="filter"
          class="elevation-1"
          light
          :loading="tableLoading"
          rows-per-page-text="Filas por página"
          >
          <template slot="items" slot-scope="props">
            <td class="text-xs-left green--text" v-on:click="goEditComplex(props.item.id)">{{ props.item.name }}</td>
            <td class="text-xs-left grey--text">{{ props.item.owner.name + ' ' + props.item.owner.lastname}}</td>
            <td class="text-xs-left grey--text">{{ props.item.owner.phone }}</td>
            <td class="text-xs-left grey--text">
              <v-tooltip left>
                <v-switch
                  v-model="props.item.status == 'active'"
                  light
                  color="green"
                  @click="disableComplex($event, props.item)"
                  slot="activator">
                  </v-switch>
                  <span>{{ props.item.status == 'active' ? 'Habilitado' : 'Inhabilitado' }}</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'


export default {
  name: "Complexes",
  data: () => ({
    actionSelected: '',
    filter: '',
    complexSelected: [],
    showConfirm: false,
    confirmMessage: '¿Estas seguro que quieres inhabilitar el complejo?',
    complexes: [],
    // Muestra un pequeño loading encima de la tabla dependiendo de su valor (True, False)
    tableLoading: false,
    headers: [
      { text: 'Nombre', value: 'name', align: 'left' },
      { text: 'Contacto', value: 'contact', align: 'left' },
      { text: 'Telefono', value: 'phone', align: 'left' },
      { text: 'Estado', value: 'status', align: 'left' },
    ],
    items: [
    ]
  }),
  created() {
    //do something after creating vue instance
    this.loadComplexes()
  },
  computed:{
    ...mapGetters([
      'currentComplexes'
    ])
  },
  methods: {
    ...mapActions([
      'loadComplexes',
      'goNewComplex',
      'goEditComplex',
      'changeStatusToAComplex'
    ]),
    disableComplex(event, complex) {
      this.actionSelected = 'disableComplex'
      this.complexSelected = complex
      let msg1 = '¿Estas seguro que quieres inhabilitar el complejo?'
      let msg2 = '¿Estas seguro que quieres habilitar el complejo?'
      this.confirmMessage = complex.status == 'active' ? msg1 : msg2
      this.showConfirm = true
    },

    confirmResponse(response) {
      if(response){
        //En caso la respuesta del usuario sea positiva
        if(this.actionSelected === 'disableComplex')
          this.changeStatusToAComplex(this.complexSelected)
        }else {
        //En caso la respuesta del usuario sea negativa
      }
      this.showConfirm = false
    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/complexes/complexes.vue